import { BuildVersion, IEnvironment } from './environment.interface';
import buildVersion from '@env/buildVersion';

export const environment: IEnvironment = {
  modules: [],
  production: false,
  routes: [],
  version: buildVersion as BuildVersion,
};
